<template>
    <div class="industry">
        <div class="marquee">
            <p v-for="item in 2" :key="item">截至{{lastDate | patchStub}},该行业已有<b>{{pubIndNum.pubIndNum |
                patchStub}}</b>家(共{{pubIndNum.indNum |
                patchStub}}家)披露{{topInfo.year}}年{{timeToReport2(topInfo.date)| patchStub}}报</p>
        </div>
        <FilterTop ref="FilterTop" :popup="popup">
            <span slot="name1">切换行业</span>
            <span slot="name2">{{findLabel(params.date,  dateList)}}</span>

            <div>
                <IndustryListRadio v-show="type === 1"
                                   :value="params.indCode"
                                   :induList="induList"
                                   @submit="induSubmit"></IndustryListRadio>

                <ReportList v-show="type === 2"
                            :date="params.date"
                            @dateChange="yearHandler"
                            :dateList="dateList"></ReportList>
            </div>


        </FilterTop>

        <!-- 散点图 -->

        <SectionCom title="行业总体财务状况与市值分布情况"
                    v-if="!hideScatterOption()"
        >
            <div class="scatter">
                <ECharts width="100%" height="4.8rem"
                         ref="echart"
                         @click="clickChart"
                         @load="dispatchAction"
                         @zr:click="legendselectchanged"
                         @legendselectchanged="legendselectchanged"
                         :noData="chartNoData"
                         :options="scatterOption"
                />
            </div>
        </SectionCom>

        <p v-else class="no-data red">金融类公司不参与评级</p>


        <div class="bg-white">

            <SortTable :table-data="tableDataSort"
                       :sortInfo="sortInfo"
                       :secCode="$route.query.secCode"
                       @sort="sort"
            />
        </div>


    </div>
</template>
<script>

    import {NewScatterOption} from './scatterOption'
    import SectionCom from "../common/sectionBlock/SectionBlock";
    import FilterTop from "../common/filterTop/FilterTop";
    import VEchart from "../common/vChart/VEchart";
    import {groupIND_PAGE, groupINDU_SELECTION} from "../../api";
    import {findLabel, setTitle} from "../../assets/js/utils";
    import {HideLoading, ShowLoading} from "../common/v-loading/loading";
    import {ShowToast} from "../common/toast/toast";
    import {timeToReport2} from "../../assets/js/reportDate";
    import IndustryListRadio from "../common/industryList/IndustryListRadio";
    import ReportList from "../common/reportList/ReportList";
    import {Evaluation} from "../../assets/js/evaluation";
    import {SendTrackLog} from "../../assets/js/point";
    import dayjs from "dayjs";
    import SortTable from "./SlideTable";
    import {FINANCE_INDUSTRY} from "../../assets/js/ind_code";
    import orderBy from 'lodash/orderBy'

    export default {
        components: {
            SectionCom,

            FilterTop,
            ECharts: VEchart,
            IndustryListRadio,
            ReportList,
            SortTable
        },
        data() {
            return {
                lastDate: dayjs().format('YYYY/MM/DD'),
                scatterOption: NewScatterOption(),
                // 报告期
                params: {
                    date: '',
                    indCode: ''
                },
                pubIndNum: {},
                topInfo: {
                    date: undefined,
                    year: undefined,
                },
                discloScore: [],
                sortInfo: {
                    field: '',
                    order: ''
                },
                type: '1',
                induList: [],       // 行业列表
                stockList: [],
                chartNoData: true,

                indCode: '',

            }
        },
        computed: {
            tableDataSort() {
                const {order, field} = this.sortInfo;
                let result = [...this.discloScore];

                if (order) {
                    result = orderBy(result, [field], order);
                    // result = Sort(result, [field], order);
                }
                return result;
            },
            dateList() {
                return this.$store.state.reportDate.dateList;
            }
        },
        created() {
            this.params.indCode = this.$route.query.indCode;
            let date = this.$route.query.date;

            if (date) {
                this.params.date = date;
                this.setTopInfo(this.params.date);
                this.initData();
                this.loadIndu(this.params.date); // 获取行业
            }

            this.$store.dispatch('loadDateList').then(() => {
                if (!date) {
                    this.params.date = this.$store.state.reportDate.latest;
                    this.setTopInfo(this.params.date);
                    this.initData();
                    this.loadIndu(this.params.date); // 获取行业
                }
            });

            if (this.$route.query.indName) {
                setTitle(this.$route.query.indName);
            }
        },
        methods: {
            async dispatchAction() {
                await new Promise(r => setTimeout(r, 200));

                let seriesIndex = -1;
                let dataIndex = -1;
                this.scatterOption.series.find((serie, i) => {
                    return serie.data.find((data, j) => {


                        if (data.secCode == this.$route.query.secCode){
                            seriesIndex = i;
                            dataIndex = j;

                            return true
                        }
                    });
                });

                if (seriesIndex === -1 || dataIndex === -1) {
                    this.legendselectchanged()
                } else {
                    this.$refs.echart.dispatchAction({
                        type: 'showTip',
                        seriesIndex: seriesIndex,
                        dataIndex: dataIndex,
                    });
                }


            },
            mousemove(e) {
                this.clickChart(e)
            },
            legendselectchanged(e) {
                this.$refs.echart.dispatchAction({
                    type: 'hideTip',
                });

                this.$refs.echart.dispatchAction({
                    type: 'updateAxisPointer',
                    currTrigger: 'leave'
                })
            },
            clickChart(e) {

                setTimeout(() => {
                    // console.log(this.$refs.echart.dispatchAction)
                    this.$refs.echart.dispatchAction({
                        type: 'showTip',
                        // 系列的 index，在 tooltip 的 trigger 为 axis 的时候可选。
                        seriesIndex: e.seriesIndex,
                        // 数据的 index，如果不指定也可以通过 name 属性根据名称指定数据
                        dataIndex: e.dataIndex,
                        // 可选，数据名称，在有 dataIndex 的时候忽略
                        // name?: string,
                        // 本次显示 tooltip 的位置。只在本次 action 中生效。
                        // 缺省则使用 option 中定义的 tooltip 位置。
                        // position: Array.<number>|string|Function,
                    })
                }, 20)

            },
            hideScatterOption() {
                return FINANCE_INDUSTRY.has(this.indCode)
            },
            setTopInfo(reportDate) {
                this.topInfo = {
                    date: reportDate,
                    year: reportDate ? reportDate.slice(0, 4) : undefined
                }
            },
            labelColor(evaluation) {
                if (evaluation === Evaluation.risk) return 'red';
                if (evaluation === Evaluation.subhealth) return 'yellow';
                if (evaluation === Evaluation.normal) return 'green';
            },
            timeToReport2,
            sort(sortInfo) {
                this.sortInfo = sortInfo;
            },
            hidePopup() {
                this.$refs.FilterTop.hide()
            },
            findLabel,
            initData() {

                ShowLoading();

                groupIND_PAGE({
                    REPORT_DATE: this.params.date,
                    IND_CODE: this.params.indCode
                }).then(res => {
                    if (res.code === '200') {
                        this.discloScore = res.data.discloScore;
                        this.pubIndNum = res.data.pubIndNum;
                        this.pubIndNum.year = this.pubIndNum.reportDate ? this.pubIndNum.reportDate.slice(0, 4) : undefined;
                        this.setOptions(res.data.mvScoreInd);

                        this.setTopInfo(this.params.date);

                        this.indCode = this.params.indCode;
                    } else {
                        ShowToast("网络错误");
                    }
                    HideLoading();
                }).catch((e) => {
                    HideLoading();
                    ShowToast("网络错误");
                });
            },
            setOptions(mvScoreInd) {

                const quality = [];
                const health = [];
                const subHealth = [];
                const risk = [];
                const setData = (item) => {
                    // 市值 与 分数 计算
                    let size = Math.sqrt((item.indexValue / 10000 / 10000) * 2)
                        / 2
                        * (item.totalScore / 100 + 1)
                        + 10;

                    return {
                        name: item.indName,
                        evaluation: item.evaluation,
                        score: item.totalScore,
                        secSname: item.secSname,
                        secCode: item.secCode,
                        indexValue: item.indexValue,
                        value: [item.indexValue, item.totalScore, size]
                    }
                };
                mvScoreInd.forEach(item => {

                    switch (item.evaluation) {
                        case Evaluation.normal:
                            quality.push(setData(item));
                            break;
                        case "健康":
                            health.push(setData(item));
                            break;
                        case Evaluation.subhealth:
                            subHealth.push(setData(item));
                            break;
                        case Evaluation.risk:
                            risk.push(setData(item));
                            break;
                    }

                });


                this.scatterOption.series[0].data = quality;
                // this.scatterOption.series[1].data = health;
                this.scatterOption.series[1].data = subHealth;
                this.scatterOption.series[2].data = risk;
                if ([quality, health, subHealth, risk].some(item => {
                    return item.length > 0
                })) {
                    this.chartNoData = false;
                } else {
                    this.chartNoData = true
                }

                this.dispatchAction()

            },

            yearHandler(year) {
                this.hidePopup();
                // this.$nextTick(() => {
                this.params.date = year.value;
                this.initData();
                this.loadIndu(this.params.date);

                SendTrackLog('div', 'click', 'dsj_ChoiceAPPcwtjh5xyym_tb_qhbgq', JSON.stringify({reportDate: year.value}));
                // });
            },

            induSubmit(indCode, indName) {
                this.hidePopup();
                this.$router.replace({
                    path: "/industry",
                    query: {
                        indCode: indCode,
                        indName: indName,
                    }
                });
                // this.$nextTick(() => {
                this.params.indCode = indCode;
                this.initData();
                // });
                SendTrackLog('div', 'click', 'dsj_ChoiceAPPcwtjh5xyym_tb_qhhy');

                indName && setTitle(indName);

               this.legendselectchanged()

            },
            popup({type, display}) {
                this.type = type;
            },
            // 行业筛选列表
            loadIndu(reportDate) {
                return groupINDU_SELECTION({"REPORT_DATE": reportDate}).then(res => {
                    if (res.code === '200') {
                        this.induList = res.data.indu;
                    }
                });
            },
            toCompany(item) {
                this.$router.push({
                    path: "/company",
                    query: {
                        code: item.secCode
                    }
                });
            },
        },
        filters: {
            keep2Decimals(value) {
                if (value || value === 0) {
                    return Number(Number(value).toFixed(2))
                }
            }
        }
    }


</script>
